//
//
//
//
//
//
//
export default {
  name: 'flag',
  props: {
    iso: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    squared: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    flagIconClass: function flagIconClass() {
      return (!!this.squared ? 'flag-icon-squared ' : '') + 'flag-icon-' + this.iso.toLowerCase();
    }
  }
};